import { Helmet } from 'react-helmet';
import Hero from '../components/Hero';
import Features from '../components/Features';
import About from '../components/About';

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Legendary Brushstrokes | Premium Miniature Painting Experience</title>
        <meta name="description" content="Dungeon Labs' premier miniature painting experience kit with uniquely sculpted miniatures, curated paints and brushes, and engaging supporting materials." />
      </Helmet>
      
      <Hero />
      <Features />
      <About />
    </>
  );
};

export default HomePage;
